import { connect } from 'react-redux';

import get from 'lodash/get';
import map from 'lodash/map';
import find from 'lodash/find';
import keys from 'lodash/keys';
import maxBy from 'lodash/maxBy';
import pickBy from 'lodash/pickBy';
import indexOf from 'lodash/indexOf';

import SubpageWrapper from './subpage_wrapper.jsx';

import {
  getSectionById,
  getSectionSelectedContent,
  getVisibleSubmenuItemsBySubpageId
} from 'zoomforth_codesbane_viewer/reducers/index.js';

import {
  setLastClickedSubmenuItemId
} from 'zoomforth_codesbane_viewer/action_creators/viewer.js';

const mapStateToProps = (state, { currentSubpage }) => {
  const sections = map(currentSubpage.orderedSectionIds, sectionId => 
    getSectionById(state, sectionId)
  );

  const sectionsSelectedContent = map(sections, section=> 
    getSectionSelectedContent(state, section)
  );
  
  const submenuItems = get(getVisibleSubmenuItemsBySubpageId(state), currentSubpage.id, []);
  
  return {
    sections,
    submenuItems,
    currentSubpage,
    sectionsSelectedContent,
    cssClassesList: currentSubpage.cssClassesList
  };
};


const mapDispatchToProps = (dispatch, { onActiveAnchorLinksChange }) => {
  return {
    onActiveAnchorLinksChange: (isAnchorActiveById, submenuItems)=> {
      // the anchor link system does double the work by aiding the scroll
      // indicator as well as the highlighted submenu items. we wrap the main
      // callback to do the additional work to highlight the most applicable
      // submenu item (anchor link).
      onActiveAnchorLinksChange(isAnchorActiveById);

      // depending on how the site has anchor links setup, multiple anchor
      // links may potentially be in the viewport at the same time. we account
      // for this by selecting the max ID visible in the viewport. we cannot
      // assume ordering in our isAnchorActiveById object hence why we build an
      // ordered list to determine the true max value to select.
      //
      // for what it's worth: this can have weird assumptions. what is the most
      // correct thing to show as displayed? I think in a lot of cases this may
      // not make sense since the instant content that has an anchor link is
      // scrolled into view we will select it.
      //
      // however...we also don't have a clear way to say "how far into the
      // viewport is the content?". this works so I digress.
      const orderedSubmenuItemIds = map(submenuItems, 'id');
      const activeSubmenuItemIds = keys(pickBy(isAnchorActiveById));
      const maxSubmenuItemId = maxBy(activeSubmenuItemIds, (submenuItemId)=> {
        return indexOf(orderedSubmenuItemIds, submenuItemId);
      });

      const submenuItem = find(submenuItems, ['id', maxSubmenuItemId]);

      if (!submenuItem) {
        dispatch(setLastClickedSubmenuItemId(null));
        return;
      }

      // this highlights the link as active in the site
      dispatch(setLastClickedSubmenuItemId(submenuItem.id));
    }
  };
};

export default connect(
  mapStateToProps,
  mapDispatchToProps
)(SubpageWrapper);
